<template>
  <div>
    <h4 class="page-title">공지사항 생성</h4>

    <create-form />
  </div>
</template>
<script>
  import CreateForm from "@/components/announcement/notice/CreateNoticeForm";

  export default {
    components: {
      CreateForm
    }
  }
</script>
